import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import SButton from '@/components/SButton/SButton.vue';

interface SNavigationDrawerProps {
  /**
   * Whether the navigation drawer is open or not.
   */
  isOpen: boolean;
  /**
   * Title of the navigation drawer.
   */
  title?: string;
}
interface SNavigationDrawerEmits {
  (event: 'close-drawer'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SNavigationDrawer',
  props: {
  isOpen: { type: Boolean },
  title: { default: '' }
},
  emits: ["close-drawer"],
  setup(__props, { emit: emits }) {

const props = __props;




const isDrawerOpen = _computed(() => props.isOpen);
const drawerTitle = _computed(() => props.title);

const closeDrawer = () => {
  emits('close-drawer');
};

const handleDrawerInput = (val: boolean) => {
  if (!val) {
    closeDrawer();
  }
};

return { __sfc: true,props, emits, isDrawerOpen, drawerTitle, closeDrawer, handleDrawerInput, _computed, SButton }
}

})